module.exports = __webpack_public_path__ + "static/img/missao.4656f42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/missao.jpg
// module id = H46i
// module chunks = 1